
/* injects from baggage-loader */

'use strict';

import { assign, findIndex } from 'lodash';

export default function (app) {
  app
    .factory('Session', SessionFactory);

  function SessionFactory($state, $rootScope) {
    'ngInject';

    let self = {
      enabled: true
    };

    self.$state = $state;

    self.create = function(){
      let updates = {};
      
      updates = {
        user: {
          level: 0,
          life: 10
        },        
        stages:[
          {
            name: "Stage 1",
            route: "main.stage-one",
            completed: false
          },
          {
            name: "Stage 2",
            route: "main.stage-two",
            completed: false
          },
          {
            name: "Stage 3",
            route: "main.stage-three",
            completed: false
          }
        ]
      };

      return sessionStorage.$session = JSON.stringify(updates);
    }

    self.save = function(updates, all){
      if(all){
        sessionStorage.$session = JSON.stringify(updates);
      } else{
        sessionStorage.$session = JSON.stringify({ user: updates.user, stages: updates.stages, trophies: updates.trophies});
      }
      return sessionStorage.$session;
    }    

    self.updateStage = function(name, updates){
      let session = self.get();
      let currentStageIndex = findIndex(session.stages, stage => stage.name === name)

      if(currentStageIndex < 0) return false;

      let stage = session.stages[currentStageIndex];

      session.stages[currentStageIndex] = assign(stage, updates);

      self.save(session);
    }

    self.updateUser = function(updates){
      let { user } = self.get();

      let newUser = assign(user, updates)
      let session = assign(self.get(), { user: newUser });

      self.save(session); // Comit changes

      $rootScope.$emit('update:status-bar'); // Apply changes in all status-bar
    }

    self.get = function(){
      try {
        return JSON.parse(sessionStorage.$session);        
      } catch (error) {
        return {};
      }
    }

    self.destroy = function(){
      delete sessionStorage.$session;
      return $state.go('login');
    }

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js